import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

// import { theme } from '../../config/theme';
import FxVignette from '../components/FxVignette';

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 2rem;
  margin-bottom: 1rem;
  padding-right: 2rem;
  padding-left: 2rem;
`;

const ImageOverlay = styled.div`
  border-radius: ${props => props.theme.borderRadius.main};
  position: absolute;
  top: -1px;
  right: -1px;
  left: -1px;
  bottom: -1px;
  z-index: 2;
  opacity: 0.1;
  transition: opacity ${props => props.theme.transitions.main.duration};
  background-image: linear-gradient(
    30deg,
    ${props => props.theme.colors.cool.light} 0%,
    ${props => props.theme.colors.cool.dark} 100%
  );
`;

const Wrap = styled.div`
  position: relative;
  transform: skewY(-3deg);
  box-shadow: ${props => props.theme.set.light.shadow.feature.small.main};
  transition: ${props => props.theme.transitions.boom.transition};
  border-radius: ${props => props.theme.borderRadius.main};
  height: 15rem;
`;

const StyledDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
  /*
  justify-content: center;
  align-items: center;
  */
  padding: 1rem;
  z-index: 9;
`;

const Image = styled.div`
  position: absolute;
  overflow: hidden;
  top: -1px;
  right: -1px;
  left: -1px;
  bottom: -1px;
  border-radius: ${props => props.theme.borderRadius.main};
  img {
    border-radius: ${props => props.theme.borderRadius.main};
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

const Title = styled.h4`
  color: ${props => props.theme.colors.pure.bright};
  margin-bottom: 0;
  font-family: ${props => props.theme.fontFamily.button};
  font-size: 1.75rem;
  text-shadow: ${props => props.theme.set.light.shadow._3d};
  top: 11rem;
  left: -1.5rem;
  position: relative;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: 2rem;
  grid-column-gap: 2rem;
  height: 21rem;
  justify-content: center;
  align-items: center;
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

const Excerpt = styled.div`
  position: absolute;
  display: block;
  z-index: 99;
  top: 0px;
  width: 100%
  height: 100%;
  opacity: 0;
  visibility: hidden;
  padding: 10% 1rem 1rem 1rem;
  color: ${props => props.theme.colors.pure.bright} 
`;

const Clicker = styled(Link)`
  font-size: 1.25rem;
  position: relative;
  display: block;
  width: 100%;
  height: 17rem;
  &:focus,
  &:hover {
    ${Wrap} {
      box-shadow: ${props => props.theme.set.light.shadow.feature.small.hover};
      transform: translateY(-12px) skewY(-1deg);
    }
    ${ImageOverlay} {
      opacity: 0.9;
    }
    ${StyledDiv}{
      /*
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.4) 35%,
        rgba(0, 0, 0, 0.5) 50%,
        rgba(0, 0, 0, 0.4) 65%,
        rgba(0, 0, 0, 0) 100%
      );
      border-radius: ${props => props.theme.borderRadius.main};
      transition: opacity ${props => props.theme.transitions.main.duration};
      */
    }
    ${Excerpt} {
      visibility: visible;
      opacity: 1;
      transition: opacity ${props => props.theme.transitions.main.duration};
      ${Excerpt} {
      }
    }
  }
  @media (max-width: 800px) {
    flex-basis: 100%;
    max-width: 100%;
    width: 100%;
    margin-bottom: 2rem;
    font-size: 1.35rem;
    ${Excerpt} {
      top: -8%;
    }  
  }
  @media (min-width: 800px) {
    font-size: 1.1225rem;
    ${Excerpt} {
      top: -3%;
    }
  }
  @media (min-width: 1200px) {
    font-size: 1.35rem;
    ${Excerpt} {
      top: -1.25rem;
    }
  }
`;

const SpanCss = styled.span`
  position: relative;
  display: block;
  width: 49%;
  height: 17rem;

  @media (max-width: 800px) {
    flex-basis: 100%;
    max-width: 100%;
    width: 100%;
    margin-bottom: 2rem;
  }
`;

const TapDiv = styled.div`
  background-color: rgba(100,0,0,0.5);
  position: relative;
  z-index: 999;
  top: -0rem;
  left: -2rem;
  width: 150%;
  height: 200%;
  opacity: 0;
  
  @media (max-width: 600px) { 
      z-index: 999;
      display: inline;
  }
`;
const TapRadio = styled.input`
  position: absolute;
  z-index: -99;
  top: -0.25rem;
  width: 100%;
  height: 100%;
  opacity: 0;
  display: none;
  
  @media (max-width: 600px) { 
      z-index: 9999;
      display: inline;

   &:checked + label {
      display: none;
    }
    &:checked {
      display: none;
    }
    &:unchecked {
      ${TapDiv} {
        display: inline;
      }
    }
  &:hover ~ ${Clicker}, &:checked ~ ${Clicker}, ${Clicker}:focus {
    ${Wrap} {
      box-shadow: ${props => props.theme.set.light.shadow.feature.small.hover};
      transform: translateY(-12px) skewY(1deg);
    }
    ${ImageOverlay} {
      opacity: 0.9;
    }
    ${StyledDiv}{
      /*
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.4) 35%,
        rgba(0, 0, 0, 0.5) 50%,
        rgba(0, 0, 0, 0.4) 65%,
        rgba(0, 0, 0, 0) 100%
      );
      border-radius: ${props => props.theme.borderRadius.main};
      transition: opacity ${props => props.theme.transitions.main.duration};
      */
    }
    ${Excerpt} {
      visibility: visible;
      opacity: 1;
      transition: opacity ${props => props.theme.transitions.main.duration};
    }
  }
`;

const Suggestions = ({ left, right }) => {
  //alert(JSON.stringify(left));
  //src={right.frontmatter.cover.childImageSharp.resize.src}
  const thumbSize = 600;

  return (
    <Row>
      {left && (
        <SpanCss>
           <TapRadio type="radio" name="r" />
        <label style={{position:`absolute`}}>
          <TapDiv className="TapDiv" id="TapDiv" name="r" />
        </label>
        <Clicker to={left.fields.slug}>
          <Wrap>
            <Image>
              <Excerpt>{left.excerpt}</Excerpt>
              <FxVignette />
              <img src={left.frontmatter.cover.childImageSharp.resize.src} alt={left.frontmatter.title} />
            </Image>
            <StyledDiv>
              <Title>{left.frontmatter.title}</Title>
            </StyledDiv>
            <ImageOverlay />
          </Wrap>
        </Clicker>
        </SpanCss>
      )}

      {right && (
      <SpanCss>
        <TapRadio type="radio" name="r" />
        <label style={{position:`absolute`}}>
          <TapDiv className="TapDiv" id="TapDiv" name="r" />
        </label>
        <Clicker to={right.fields.slug}>
          <Wrap>
            <Image>
              <Excerpt>{right.excerpt}</Excerpt>
              <FxVignette />
              <img src={right.frontmatter.cover.childImageSharp.resize.src} alt={right.frontmatter.title} />
            </Image>
            <StyledDiv>
              <Title>{right.frontmatter.title}</Title>
            </StyledDiv>
            <ImageOverlay />
          </Wrap>
        </Clicker>
      </SpanCss>
      )}
    </Row>
  );
};

// const Suggestions = ({ left, right }) => {
//   return (
//     <Grid>
//       <Clicker to={left.fields.slug}>
//         <Wrap>
//           <Image>
//             <img
//               src={left.frontmatter.cover.childImageSharp.resize.src}
//               alt={left.frontmatter.title}
//             />
//           </Image>
//           <StyledDiv>
//             <Title>{left.frontmatter.title}</Title>
//           </StyledDiv>
//           <ImageOverlay />
//         </Wrap>
//       </Clicker>
//       <Clicker to={right.fields.slug}>
//         <Wrap>
//           <Image>
//             <img
//               src={right.frontmatter.cover.childImageSharp.resize.src}
//               alt={right.frontmatter.title}
//             />
//           </Image>
//           <StyledDiv>
//             <Title>{right.frontmatter.title}</Title>
//           </StyledDiv>
//           <ImageOverlay />
//         </Wrap>
//       </Clicker>
//     </Grid>
//   );
// };

export default Suggestions;

Suggestions.propTypes = {
  left: PropTypes.any.isRequired,
  right: PropTypes.any.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Suggestions.jsx